import React from "react";
import { __t } from "../../utils/translate";

type EmptyCartProps = {
    className?: string;
};

const EmptyCart: React.FC<EmptyCartProps> = ({ className }) => {
    return (
        <div className={`${className} w-full mx-auto`}>

            <h2 className="mt-5 pt-4 border-t border-stroke-color text-base-16 text-start w-full">
                {__t("No products in the cart.")}
            </h2>
        </div>
    );
};

export default EmptyCart;
